<div class="card">
  <app-header titulo="Pesagem" descricao="Dados de Pesagem"></app-header>
  <p-toast />
  <p-table [value]="pesagens91p" dataKey="id" [loading]="loading" #dt [globalFilterFields]="['empresaErp','tanqueErp','cdMaterialErp','idTanquePi','cdMaterialPi']" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [rowsPerPageOptions]="[20, 50, 100]" [paginator]="true" [rows]="20" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros">
    <ng-template pTemplate="caption">
      <div class="flex">
        <a [routerLink]="['novo']"><button icon="pi pi-plus" label="Novo Cadastro" pButton></button></a>

        <span class="p-input-icon-left ml-auto">
          <i class="pi pi-search"></i>
          <input pInputText type="text" (input)="dt.filterGlobal($any($event.target)?.value, 'contains')" placeholder="Pesquisar" />
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th>Empresa Erp</th>
            <th>Tanque Erp</th>
            <th>Código Material Erp</th>
            <th>Id Tanque Pi</th>
            <th>Código Material Pi</th>
            <th></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-pesagem91p>
        <tr>
            <td>{{ pesagem91p.empresaErp }}</td>
            <td>{{ pesagem91p.tanqueErp }}</td>
            <td>{{ pesagem91p.cdMaterialErp }}</td>
            <td>{{ pesagem91p.idTanquePi }}</td>
            <td>{{ pesagem91p.cdMaterialPi }}</td>
            <td>
              <a [routerLink]="['editar', pesagem91p.id]">
                <p-button icon="pi pi-pencil"
                          severity="primary"
                          class="m-2"
                          [rounded]="true"
                          [outlined]="true" >
                </p-button>
              </a>

              <p-button
                        icon="pi pi-trash"
                        severity="danger"
                        [rounded]="true"
                        [outlined]="true"
                        (onClick)="confirmarExclusao(pesagem91p.id)" />
            </td>

        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <td colspan="10">Nenhum registro encontrado</td>
    </ng-template>
  </p-table>
  <p-confirmDialog [style]="{ width: '450px' }" />
</div>
